import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetOAuthSettings($businessId: String!) {
    getOAuthSettings(businessId: $businessId) {
      businessId
      provider
      domains
      metadata {
        createdAt
        createdBy
      }
      uuid
    }
  }
`

export const getOAuthSettingsKey = getQueryNames(query)[0]

export default query
